import SignDisplay from './SignDisplay';

export default class Sign {
    constructor(data) {
        Object.assign(this, data);

        this.displays = [
            'video',
            'image',
            'la_hend',
            'photo',
        ].map(desc => new SignDisplay(desc, data[desc]));
    }
}
